var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2262_10964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15503 4.32158H6.65503C6.1246 4.32158 5.61589 4.53229 5.24082 4.90737C4.86574 5.28244 4.65503 5.79115 4.65503 6.32158V20.3216C4.65503 20.852 4.86574 21.3607 5.24082 21.7358C5.61589 22.1109 6.1246 22.3216 6.65503 22.3216H18.655C19.1855 22.3216 19.6942 22.1109 20.0692 21.7358C20.4443 21.3607 20.655 20.852 20.655 20.3216V6.32158C20.655 5.79115 20.4443 5.28244 20.0692 4.90737C19.6942 4.53229 19.1855 4.32158 18.655 4.32158H16.155",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65503 6.72158V4.82158C8.65503 4.68897 8.70771 4.56179 8.80148 4.46803C8.89524 4.37426 9.02242 4.32158 9.15503 4.32158C9.43103 4.32158 9.65903 4.09758 9.70703 3.82558C9.85503 2.97358 10.429 1.32158 12.655 1.32158C14.881 1.32158 15.455 2.97358 15.603 3.82558C15.651 4.09758 15.879 4.32158 16.155 4.32158C16.2876 4.32158 16.4148 4.37426 16.5086 4.46803C16.6024 4.56179 16.655 4.68897 16.655 4.82158V6.72158C16.655 6.88071 16.5918 7.03332 16.4793 7.14584C16.3668 7.25836 16.2142 7.32158 16.055 7.32158H9.25503C9.0959 7.32158 8.94329 7.25836 8.83076 7.14584C8.71824 7.03332 8.65503 6.88071 8.65503 6.72158Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2262_10964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.655518 0.321579)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.77398957c43923e112a482d291334896.svg";
export { ForwardRef as ReactComponent };